import React from "react";
import { useCurrency, CURRENCY_SYMBOLS } from "../context/CurrencyContext";

// Subtle £ GBP | $ USD | € EUR selector. Hidden if only one currency is enabled.
export default function CurrencySwitcher({ className = "" }) {
  const { currency, setCurrency, enabled } = useCurrency();
  if (!enabled || enabled.length < 2) return null;
  return (
    <div className={`inline-flex items-center rounded-sm border border-white/15 overflow-hidden ${className}`} data-testid="currency-switcher">
      {enabled.map((c) => (
        <button key={c} type="button" onClick={() => setCurrency(c)} data-testid={`currency-${c}`}
          className={`px-2.5 py-1 text-xs font-display font-bold tracking-wide transition-colors ${currency === c ? "bg-pgt-green text-black" : "text-white/55 hover:text-white"}`}>
          {CURRENCY_SYMBOLS[c]} {c}
        </button>
      ))}
    </div>
  );
}
